import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import EFPicture from '@elem/ui/ef-picture';
import EcoImg from 'eco-design/base/eco-img';

const SmartMeter: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('SmartMeter');
    return (
        <div className={styles.SmartMeter + ' page-layout'}>
            <div className="page-layout-left">
                <div className="page-layout-left-icon">
                    <EFPicture src="https://websiteoss.ecoflow.com/upload/image/1751266020293/Mask%20group.png" />
                </div>
                <div className="page-layout-left-title">{t('title')}</div>
                <div className="page-layout-left-desc">{t('desc')}</div>
            </div>
            <div className="page-layout-right">
                <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1752548428980/largge.png" />
            </div>
        </div>
    );
};

export default SmartMeter;
